'use strict';

angular.module('mean.admin-panel').controller('BuilderAdminUsersController', ['$scope', 'Users', 'Global', 'MeanUser', '$filter', 'toaster', '$q', 'AdminPanel', 'tradeCodeService', 'userService',
  function($scope, Users, Global, MeanUser, $filter, toaster, $q, AdminPanel, tradeCodeService, userService) {
    $scope.global = Global;
    $scope.package = {
      name: 'admin-panel'
    };

    var array = MeanUser.user.username.split('', 9);

    $scope.contractor_code = array[2] + array[3] + array[4];

    //this is a builder admin account so the trade code is
    //automatically set to 00
    $scope.trade_code = "00";

    console.log('got the company code value: ' + $scope.contractor_code);

    for(var i=0; i<MeanUser.user.roles.length; i++) {
        if (MeanUser.user.roles[i] === 'builder_admin') {
            $scope.builder_admin = true;
        }
    }

    if(!$scope.builder_admin) {
        toaster.pop('error', 'Admin Panel', 'You do not have the proper permissions for this page.');
        return;
    }

    $scope.userSchema = [{
        title: 'Email',
        schemaKey: 'email',
        type: 'text',
        inTable: true
    }, {
        title: 'Name',
        schemaKey: 'name',
        type: 'text',
        inTable: true
    }, {
        title: 'Username',
        schemaKey: 'username',
        type: 'username',
        inTable: true
    }, {
        title: 'Roles',
        schemaKey: 'roles',
        type: 'select',
        options: [{
            name: 'Admin',
            code: 'builder_admin'
        }, {
            name: 'Builder',
            code: 'builder'
        }, {
            name: 'Purchasing Agent',
            code: 'purchasing_agent'
        }, {
            name: 'Project Manager',
            code: 'project_manager'
        }],
        inTable: true
    }, {
        title: 'Password',
        schemaKey: 'password',
        type: 'password',
        inTable: false
    }, {
        title: 'Phone',
        schemaKey: 'phone',
        type: 'phone',
        inTable: true
    }, {
        title: 'Pay Rate',
        schemaKey: 'pay_rate',
        type: 'text',
        inTable: true
    }, {
        title: 'Active',
        schemaKey: 'active',
        type: 'boolean',
        inTable: true
    }];

    $scope.user = {
        'contractor_code': $scope.contractor_code
    };

    $scope.init = function() {
        if(!$scope.contractor_code) {
            toaster.pop('error', 'Admin Panel', 'Your request cannot be processed.');
            return;
        }

        Users.query({'trade': MeanUser.user.trade[0], 'contractor_code': $scope.contractor_code}, function(users) {
            $scope.users = users;
        });
    };

    $scope.add = function() {
        if (!$scope.users) $scope.users = [];

        console.log('adding user %s with role %s and trade %s', $scope.user.name, $scope.user.roles, $scope.trade_code);

        console.log(userService.generateId($scope.users, "00", $scope.contractor_code));

        var user = new Users({
            email: $scope.user.email,
            name: $scope.user.name,
            username: userService.generateId($scope.users, $scope.trade_code, $scope.contractor_code),
            password: $scope.user.password,
            confirmPassword: $scope.user.password,
            roles: $scope.user.roles.code,
            trade: 'Builder',
            contractor_code: $scope.contractor_code,
            pay_rate: $scope.user.pay_rate,
            active: true,
            phone: $scope.user.phone
        });

        user.$save(function(response) {
            toaster.pop('success', 'Admin Panel', 'User ' + response.name + ' added to database');
            $scope.users.push(response);

            $scope.user.name = '';
            $scope.user.username = '';
            $scope.user.email = '';
            $scope.user.password = '';
            $scope.user.roles = '';
            $scope.user.division_code = '';
            $scope.user.pay_rate = '';
            $scope.user.phone = '';
        }, function(error) {
            if(angular.isArray(error.data)) {
                error.data.forEach(function(item) {
                    toaster.pop('error', 'Admin Panel', item.msg);
                });
            } else {
                if(error.data.msg) {
                    toaster.pop('error', 'Admin Panel', error.data.msg);
                } else {
                    toaster.pop('error', 'Admin Panel', error.data);
                }
            }
        });
    };

    $scope.update = function(user) {
        if(angular.isArray(user.roles)) {
            user.roles = user.roles[0].code;
        } else { 
            user.roles = user.roles.code;
        }
        user.$update(function(response) {
            toaster.pop('success', 'User Admin Panel', 'User ' + response.name + ' has been updated');
        }, function(error) {
            toaster.pop('error', 'User Admin Panel', error);
        });
    };

  }
]);



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/controllers/builderAdminUsers.js